import { IAlertsListQueryParams } from "./@types/alertsgrid";

export const alertQueryKeys = {
  listAlerts: ["listAlerts"],
  listAlertsWithParams: (qp?: IAlertsListQueryParams) => [
    ...alertQueryKeys.listAlerts,
    qp
  ],
  latestAlerts: (fetchCount?: number) => ["getAlerts", fetchCount],
  subscriptionsCount: () => ["subscriptionCount"]
};
